(function(){
	'use strict';
	angular.module('app.leanProjects')
		.controller('assessmentsSummary', assessmentsSummary);
	assessmentsSummary.$inject = ['$scope', '$timeout', '$location', 'leanFilterService', 'tableRenderService', 'tableService', 'ASSESSMENTS', '$state', 'storeService'];

	function assessmentsSummary($scope, $timeout, $location, leanFilterService, tableRenderService, tableService, ASSESSMENTS, $state, storeService) {
		var vm = this;

		// Redirect to projects if not allowed to current customer
		if (ASSESSMENTS.allowedCustomers.indexOf(globalConfig.customer.id) < 0)  {
			$location.path('/lean-projects/view-projects').replace();
		}

		var unsubscribe;
		var reportSettingsName = 'assessments-summary';
		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var rendererParams = {};
		// Extra drilldown query params to parse
		var extraFilters = [];
		var pinnedColumns = [];
		var defaultFilters = [
			{ 'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true }
		];

		$scope.filterService = leanFilterService;

		// Set navigation properties
		$timeout(function(){
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#assessmentSummary').addClass('selected');
		}, 0);
		vm.showExcel = false;

		vm.getMeta = getMeta;
		vm.getData = getData;
		vm.reportName = 'Assessments summary';

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				var count_elementName = 0;
				var count_categoryName = 0;
				var count_systemName = 0;
				var lastCategoryName = '';
				var lastSystemName = '';
				var oldResponseData = response[0];
				response[0] = { data: [] };
				response[0].data = oldResponseData.map(function(row) {
					count_elementName = count_elementName + 1;

					if (lastCategoryName !== row.categoryName) {
						count_categoryName = count_categoryName + 1;
						count_systemName = 0;
						count_elementName = 1;
						lastCategoryName = row.categoryName;
					}

					if (lastSystemName !== row.systemName) {
						count_systemName = count_systemName + 1;
						count_elementName = 1;
						lastSystemName =  row.systemName;
						row.systemName = count_categoryName + '.' + count_systemName + '. '
									+ row.systemName;
					} else {
						row.systemName = '';
					}

					row.elementName = count_categoryName + '.' + count_systemName + '.'
								+ count_elementName + '. ' + row.elementName;
					row.categoryName = count_categoryName + '. ' + row.categoryName;
					return row;
				});
				return response;
			});
		}

		init();

		var columns = [
			{
				'id': 'categoryName',
				'display': 'Category',
				'width': 240,
				'enableGrouping': true,
				'enablePinning': false,
				'grouped': true
			},
			{
				'id': 'systemName',
				'display': 'System',
				'width': 240,
				'enablePinning': false,
				'sort': false
			},
			{
				'id': 'elementName',
				'display': 'Element',
				'width': 240,
				'enablePinning': false,
				'sort': false
			},
			{
				'id': 'rating',
				'display': 'Score',
				'width': 80,
				'enablePinning': false,
				'sort': false
			},
			{
				'id': 'comments',
				'display': 'Comments And Actions',
				'width': 140,
				'enablePinning': false,
				'sort': false
			}
		];

		function navigateToBaseReport() {
			$state.go('.', { reportId: undefined });
		}
		vm.navigateToBaseReport = navigateToBaseReport;
		vm.baseReportDisplay = vm.reportName;
		$scope.baseReportName = vm.baseReportDisplay;
		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;
		if (reportSettingsId) {
			vm.showInfo = true;
		}
		
		var meta = {
			reportSettingsId: reportSettingsId,
			reportSettingsName: reportSettingsName,
			reportName: vm.reportName,
			reportUrl: '{0}/Assessments',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			extraParams: extraParams,
			rendererParams: rendererParams,
			hideSearch: true,
			setColumnDefaults: true
		};

		function init() {
			leanFilterService.clearFilters();
			leanFilterService.useFactoryFilter = true;

			var siteFilter = $scope.filterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;

			$scope.filterService.setMasterFilterList([]);
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
			$scope.filterService.defaultFilters = defaultFilters;
			$scope.filters = $scope.filterService.masterFilterList;
			$scope.rangeFilters = $scope.filterService.masterRangeFilterList;
			$scope.stringFilters = $scope.filterService.masterStringFilterList;
			$scope.singleSelectFilters = $scope.filterService.masterSingleSelectFilterList;
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});

		$scope.$on('$destroy', function() {
			if (unsubscribe) unsubscribe();
		});
	}
})();
